export const colors = {
  color1: "linear-gradient(to top, #ff4b5c, #ff8c42)",
  color2: "linear-gradient(to top, #6a11cb, #2575fc)",
  color3: "linear-gradient(to top, #ff9a8b, #ff6a00)",
  color4: "linear-gradient(to top, #2d92d1, #56ccf2)",
  color5: "linear-gradient(to top, #6a9a8e, #0f3443)",
  color6: "linear-gradient(to top, #005a80, #0f3443)",
  color7: "linear-gradient(to top, #4d5aa6, #0f3443)",
  color8: "linear-gradient(to top, #009dae, #0f3443)",
  color9: "linear-gradient(to top, #669999, #0f3443)",
};

const microsoftColors = ["#12B8FF", "#01DC03", "#FD4499", "#DF19FB", "#FF3A06"];

export const getColorForMember = (index) => {
  return microsoftColors[index % microsoftColors.length];
};

// theme.js

export const lightTheme = {
  background: "#ffffff",
  cardBackground: "#ffffff",
  textPrimary: "#000000",
  textSecondary: "rgba(0, 0, 0, 0.45)",
  border: "#f0f0f0",
  progressColor: "#40a9ff",
  backgroundGradient: "linear-gradient(to right, #f0f2f5, #e6f7ff)",
};

export const darkTheme = {
  background: "#1f1f1f",
  cardBackground: "#2a2a2a",
  textPrimary: "rgba(255, 255, 255, 0.85)",
  textSecondary: "rgba(255, 255, 255, 0.45)",
  border: "#303030",
  progressColor: "#1890ff",
  backgroundGradient: "linear-gradient(to right, #1f1f1f, #2a2a2a)",
};
